<template>
  <b-row class="project-title-detail">
		<b-col>
			<h1 class="title project">{{ projectName }}</h1>
			<div class="project-specs">
				<div>
					<p>
						<strong>Resident Engineer</strong>: {{ residentEngineerTitle }}
					</p>
					<p>
						<strong>Project Manager</strong>: {{ projectManagerTitle }}
					</p>
				</div>
				<div>
					<p>
						<strong>Total Budget</strong>: {{ projectCost }}
					</p>
					<p>
						<strong>Scheduled Work Days</strong>: {{ projectDays ? projectDays + " days" : "Unknown" }}
					</p>
				</div>
			</div>
		</b-col>
		<b-col>
			<div class="tool align-right" style="margin-bottom: 20px">
				<b-button @click="$emit('addMeeting')" variant="primary" class="meeting">
					Create meeting
				</b-button>
				<b-dropdown right class="additional-btn kebab">
					<template #button-content>
						<b-icon
							class="icon kebab"
							icon="three-dots-vertical"
							font-scale="1"
						></b-icon>
					</template>
					<b-dropdown-item @click="$emit('showMeetNowPrompt')">
						Meet Now
					</b-dropdown-item>
					<b-dropdown-item @click="$emit('addMeeting')">
						Schedule Meeting
					</b-dropdown-item>
				</b-dropdown>
			</div>
			<b-row align-h="end">
				<b-col v-if="ownerLogo" cols="auto">
					<div class="company-logo-wrapper">
						<div class="widget logo-container">
							<img :src="ownerLogo" class="" alt="Owner Logo" />
						</div>
					</div>
				</b-col>
				<b-col v-if="contractorLogo" cols="auto">
					<div class="company-logo-wrapper">
						<div class="widget logo-container">
							<img :src="contractorLogo" class="" alt="Contractor Logo" />
						</div>
					</div>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
// import axios from "axios";
// import ComponentName from "@/components/ComponentName.vue";

export default {
  components: {
    
  },
  props: {
    project: { type: Object, required: true }
  },
  data() {
    return {

    }
  },
  computed: {
		projectName() {
			return this.project.projectName;
		},
		residentEngineerTitle() {
			return this.project.hasOwnProperty('primaryOwner') ? this.project.primaryOwner.name : '';
		},
		projectManagerTitle() {
			return this.project.hasOwnProperty('primaryContractor') ? this.project.primaryContractor.name : '';
		},
		projectCost() {
			return this.$formatter.toCurrency(this.project.projectCost);
		},
		projectDays() {
			return this.$formatter.daysFromDates(
        this.project.startDate,
        this.project.endDate
      );
		},
		ownerLogo() {
			return this.project.primaryOwner.organizationLogo;
		},
		contractorLogo() {
			return this.project.primaryContractor.organizationLogo;
		},
  },
  watch: {

  },
  mounted() {
    // this.loadData();
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
::v-deep .additional-btn.kebab {
  button {
    background: transparent;
    border-radius: 0;
    border-width: 0;
    padding: 10px;

    &.dropdown-toggle {
      background: transparent;
      &:after {
        content: none;
      }
    }
  }
}
::v-deep .tool {
  display: flex;
  justify-content: flex-end;
}
</style>
